var map = {
	"./en/formalities.json": [
		26619,
		6619
	],
	"./fr/formalities.json": [
		38508,
		8508
	],
	"./nl/formalities.json": [
		38486,
		8486
	],
	"./zh/formalities.json": [
		11166,
		1166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98614;
module.exports = webpackAsyncContext;